import React, { Component } from 'react';
import { 
  Table, 
  Row, 
  Col, 
  Button, 
  Tooltip, 
  OverlayTrigger, 
  Glyphicon 
} from 'react-bootstrap';
import { connect } from 'react-redux';
import './TaskBar.css';
import { 
  toggleHideUnhide, 
  updateFontSize, 
  updateSummaryInput, 
  updateDbQuarterSummary,
  onBuySell, 
  onAddRemove, 
  onQuarterly, 
  onPreviewQuarterly,
  getTickerInfo, 
  changeCurrentQuarter, 
  consolidateFiles,
  updateSPXQuarterly
} from '../../../actions';
import BuySellModal from './BuySellModal';
import AddRemoveModal from './AddRemoveModal';
import QuarterlyModal from './QuarterlyModal';
import SummaryModal from './SummaryModal';
import ConsolidateSellsModal from './ConsolidateSellsModal';
import { formatPercent } from '../Helpers';

class TaskBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBuySellModal: false,
      showAddRemoveModal: false,
      showQuarterlyModal: false,
      showSummaryModal: false,
      showConsolidateSellsModal: false
    };
  }

  openModal = (name) => { this.setState({ [name]: true }); }

  closeModal = (name) => { this.setState({ [name]: false }); }

  updateFontSize = (value) => {
    const { fontSize } = this.props.settings;
    this.props.updateFontSize(+((fontSize + value).toFixed(1)));
  }

  render() {

    const { benchmarkInfo, quarterInfo } = this.props;
    if (benchmarkInfo.length < 1) return null;

    //const SPYInfo = benchmarkInfo[0];
    const SPXInfo = benchmarkInfo[1];

    const activePortfolioId = this.props.session.activePortfolioUser.portfolio_id;  
    
    const userPrivilege = this.props.session.activePortfolioUser.privilege;    

    const tooltipDecrease = (
      <Tooltip id="tooltipDecrease">
        Decrease font size: {this.props.settings.fontSize}
      </Tooltip>
    );

    const tooltipIncrease = (
      <Tooltip id="tooltipIncrease">
        Increase font size: {this.props.settings.fontSize}
      </Tooltip>
    );

    const tooltipLastUpate = (
      <Tooltip id="toolTipLastUpdate">
        Last Updated: {this.props.session.lastUpdateTime}
      </Tooltip>
    );

    return (
      <div className="taskbar">

        <BuySellModal 
          showBuySellModal={this.state.showBuySellModal} 
          closeModal={this.closeModal} 
          onBuySell={this.props.onBuySell}  
          activePortfolioId={activePortfolioId} />

        <AddRemoveModal 
          showAddRemoveModal={this.state.showAddRemoveModal} 
          closeModal={this.closeModal} 
          onAddRemove={this.props.onAddRemove}  
          activePortfolioId={activePortfolioId} />

        <QuarterlyModal 
          showQuarterlyModal={this.state.showQuarterlyModal} 
          closeModal={this.closeModal} 
          onQuarterly={this.props.onQuarterly} 
          onPreviewQuarterly={this.props.onPreviewQuarterly}
          activePortfolioId={activePortfolioId} />

        <SummaryModal 
          updateSPXQuarterly={this.props.updateSPXQuarterly}
          benchmarkInfo={this.props.user.benchmarkInfo}
          showSummaryModal={this.state.showSummaryModal} 
          closeModal={this.closeModal} 
          quarterInfo={this.props.user.quarterInfo} 
          updateSummaryInput={this.props.updateSummaryInput} 
          updateDbQuarterSummary={this.props.updateDbQuarterSummary} 
          changeCurrentQuarter={this.props.changeCurrentQuarter}
          activePortfolioId={activePortfolioId} 
          userPrivilege={userPrivilege} />

        <ConsolidateSellsModal 
          showConsolidateSellsModal={this.state.showConsolidateSellsModal} 
          closeModal={this.closeModal} 
          consolidateFiles={this.props.consolidateFiles} />

        <Row>
          <Col sm={12} md={6}>
            <div className="taskbar-summary-container">
              <Table className="summary">        
                <tbody>
                  <tr>
                    <td>SCM</td>
                    <td>SPX</td>
                    {/* <td>SPY</td> */}

                    <td>Q{quarterInfo.currentQuarter} SCM</td>
                    <td>Q{quarterInfo.currentQuarter} SPX</td>
                    <td>Q{quarterInfo.currentQuarter} DIFF</td>

                    <td>SCM</td>
                    <td>SPX</td>
                    <td>DIFF</td>
                  </tr>
                  <tr>
                    {console.log(SPXInfo)}
                    <td>{ formatPercent(quarterInfo.SCMSummary) }</td>
                    <td>{ formatPercent(SPXInfo.percentChange) }</td>
                    {/* <td>{ formatPercent(SPYInfo.percentChange) }</td> */}

                    <td>{ formatPercent(quarterInfo[`SGqtr${quarterInfo.currentQuarter}`]) }</td>
                    <td>{ formatPercent(quarterInfo[`SPXqtr${quarterInfo.currentQuarter}`]) }</td>
                    <td>{ formatPercent(quarterInfo[`qtr${quarterInfo.currentQuarter}Diff`]) }</td>

                    <td>{ formatPercent(quarterInfo.SGTotal) }</td>
                    <td>{ formatPercent(quarterInfo.SPXTotal) }</td>
                    <td>{ formatPercent(quarterInfo.totalDiff) }</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
          <Col sm={12} md={6}>
            <div className="taskbar-btn-group">

              <Button bsStyle="primary" onClick={() => this.openModal('showSummaryModal')}>Summary</Button>

              { userPrivilege !== 'readonly' 
                && <Button bsStyle="primary" onClick={() => this.openModal('showConsolidateSellsModal')}>Consolidate</Button> }

              <OverlayTrigger placement="top" overlay={tooltipDecrease}>
                <Button 
                  bsStyle="primary" 
                  onClick={() => this.updateFontSize(-0.1)}>
                  <strong>-</strong></Button>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={tooltipIncrease}>
                <Button 
                  bsStyle="primary" 
                  onClick={() => this.updateFontSize(0.1)}>
                <strong>+</strong></Button>
              </OverlayTrigger>

              { !this.props.settings.hideColumns 
                && userPrivilege !== 'readonly' 
                && <Button bsStyle="primary" onClick={() => this.openModal('showQuarterlyModal')}>Quarterly</Button> }

              { userPrivilege !== 'readonly' 
                && <Button bsStyle="primary" onClick={() => this.openModal('showAddRemoveModal')}>Add / Remove</Button> }

              <Button bsStyle="primary" onClick={() => this.openModal('showBuySellModal')}>Buy / Sell</Button>

              <Button bsStyle="primary" onClick={() => this.props.toggleHideUnhide()}>{this.props.settings.hideColumns ? 'U' : 'H'}</Button>

              <OverlayTrigger placement="top" overlay={tooltipLastUpate}>
                <Button bsStyle="primary" onClick={() => this.props.getTickerInfo()}><Glyphicon style={{ fontSize: 11 }} glyph="refresh" /></Button>
              </OverlayTrigger>

            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStatetoProps({ settings, user, session }) {
  return {
    settings,
    user,
    session
  };
}

export default connect(mapStatetoProps, { 
  toggleHideUnhide, 
  updateFontSize,
  updateSummaryInput, 
  updateDbQuarterSummary, 
  onBuySell, 
  onAddRemove, 
  onQuarterly, 
  onPreviewQuarterly,
  getTickerInfo,
  changeCurrentQuarter, 
  consolidateFiles,
  updateSPXQuarterly
})(TaskBar);